import { useState } from "react";
import Modal from "../Modal";
import ExportModal from "./ExportModal";

function ExportButton() {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <button type="button" onClick={() => setIsOpen(true)}>
                Export
            </button>
            <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
                <ExportModal />
            </Modal>
        </>
    );
}

export default ExportButton;
